export default {
    title: "Nástenka",
    text_0: "Môj dashboard",
    text_1: "Hodnota ponúk tento mesiac",
    text_2: "Celková hodnota ponúk",
    text_3: "Počet klientov",
    text_4: "Počet Moje firmy",
    text_5: "Počet Položky a ceny",
    text_6: "Počet integrácií SuperFaktura",
    text_7: "Počet užívateľov bez ponuky",
    text_8: "Počet užívateľov s 1 ponukou",
    text_9: "Počet užívateľov s 2-5 ponukami",
    text_10: "Počet užívateľov s viac ako 5 ponukami",
    text_11: "Počet všetkých užívateľov",
    text_12: "Počet všetkých ponuk",
    text_13: "Počet všetkých klientov",
    text_14: "Počet tmavých ponúk",
    text_15: "Počet svetlých ponúk",
    text_16: "Hodnota tvojich ponúk",
    text_17: "Počet tvojich ponúk",
    text_18: "Zaregistrovaní užívatelia",
    text_19: "Počet všetkých ponúk",
    text_20: "TOP 10 používateľov podľa počtu ponúk",
    text_21: "Tvoje posledné ponuky",
    text_22: "Prejsť na všetky ponuky",
    text_23: "Aktuálne nemáš vytvorené žiadne cenové ponuky. Nechceš nejakú vytvoriť?",
    text_24: "Vytvoriť ponuku",
    text_25: "Odoslané emaily",
    text_26: "Oblasť podnikania",
    text_27: "Zdroj kontaktov",
    text_28: "Priemerná hodnota všetkých ponúk",
    text_29: "TOP 10 používateľov podľa celkovej ceny ponúk",
    text_30: "TOP 10 používateľov podľa priemernej ceny ponúk",
    text_31: "Stavy cenových ponúk",

    // Tour buttons
    tour_start:  "Spustiť tour",
    tour_stop:   "Ukončiť prehliadku",
    tour_back:   "Naspäť",
    tour_next:   "Pokračovať",
    tour_finish: "Dokončiť tour",
    tour_skip:   "Preskočiť tour",

    // Tour step content
    tour_s0_title: "Ahoj, vitaj v DOFFERO!",
    tour_s0_text:  "V krátkosti ti ukážem, kde sa čo nachádza.",
    tour_s1_title: "Dôležité čísla a štatistiky",
    tour_s1_text:  "V tejto časti uvidíš vytiahnuté dôležité čísla ohľadom tvojich cenových ponúk. Ak chceš vidieť viac dát, zavítaj do sekcie Štatistiky.",
    tour_s2_title: "Vytvorili sme ti prvú ponuku",
    tour_s2_text:  "Vytvorili sme pre teba prvú testovaciu ponuku, aby si videl/a, ako môže vyzerať a aké má možnosti.",
    tour_s3_title: "Otvor svoju ponuku",
    tour_s3_text:  "Kliknutím na toto tlačidlo otvoríš svoju ponuku ako online link, ktorý môžeš poslať klientovi.",
    tour_s4_title: "Stav ponuky",
    tour_s4_text:  "Táto gulička reprezentuje stav tvojej ponuky. Ak svieti na zeleno, ponuka je aktívna a verejná. Ak je žltá, tak je v stave konceptu. Ak vidíš červenú, tak to znamená, že je ponuka neaktívna.",
    tour_s5_title: "Uprav svoju ponuku",
    tour_s5_text:  "Kliknutím na toto tlačidlo sa dostaneš do módu editácie ponuky a môžeš ju upravovať.",
    tour_s6_title: "Duplikuj svoju ponuku",
    tour_s6_text:  "Kliknutím sem duplikuješ svoju ponuku a ľahko podľa nej spravíš novú.",
    tour_s7_title: "Vytvor novú ponuku",
    tour_s7_text:  "Keď budeš chcieť vytvoriť novú cenovú ponuku, klikni na toto tlačidlo.",
    tour_s8_title: "Správa klientov (CRM)",
    tour_s8_text:  "Spravuj svojich klientov na jednom mieste. Pridaj všetky potrebné údaje, nastav si zdroj, kde si klienta získal a dokonca si môžeš nastaviť, aby sme ti pripomenuli, že sa máš ozvať klientovi.",
    tour_s9a_title: "Farebnosť ponúk",
    tour_s9a_text:  "Nastav si farby cenových ponúk podľa svojej značky.",
    tour_s9b_title: "Pridaj recenzie do ponuky",
    tour_s9b_text:  "Pridaj si recenzie svojich klientov do cenovej ponuky a zvýš šancu na úspech.",
    tour_s9c_title: "Kolegovia či zamestnanci",
    tour_s9c_text:  "Pridaj svojich kolegov či zamestnancov pod svoj účet a pracujte na ponukách spolu pod jednou firmou.",
    tour_s10a_title: "Databáza položiek",
    tour_s10a_text:  "Priprav si databázu položiek a ich cien vopred a potom ich ľahko používaj pri tvorbe ponúk.",
    tour_s10b_title: "Štatistiky",
    tour_s10b_text:  "Na tomto mieste nájdeš detailné štatistiky k svojim ponukám a klientom. Ak máš pridaných kolegov, tiež tu nájdeš info k ich výkonnosti.",
    tour_s11a_title: "Máš viac firiem?",
    tour_s11a_text:  "Ak máš viac firiem, nemusíš si pre ne vytvárať nové kontá. Vytváraj ponuky pod jedným účtom.",
    tour_s11b_title: "Donastavuj si účet",
    tour_s11b_text:  "Prezri si možnosti nastavení a donastav si čo potrebuješ.",
};
